import { IconProps } from "../../utils/global-types/global-types";

const LocationIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <g clipPath="url(#clip0_7124_91053)">
        <path
          fill="currentColor"
          d="M9 1.5c-3.101 0-5.625 2.541-5.625 5.666 0 4.439 5.096 9.023 5.313 9.215a.47.47 0 0 0 .624 0c.217-.192 5.313-4.776 5.313-9.215C14.625 4.04 12.101 1.5 9 1.5m0 8.75a3.13 3.13 0 0 1-3.125-3.125A3.13 3.13 0 0 1 9 4a3.13 3.13 0 0 1 3.125 3.125A3.13 3.13 0 0 1 9 10.25"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_7124_91053">
          <path fill="#fff" d="M1.5 1.5h15v15h-15z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default LocationIcon;
